export default "__VITE_ASSET__BysTTE3O__"